<!--<splash-screen></splash-screen>-->

<router-outlet></router-outlet>

@if (showLoader) {
  <app-spinner></app-spinner>
}
